import { render } from "./Swap.vue?vue&type=template&id=004a0810&scoped=true"
import script from "./Swap.vue?vue&type=script&lang=js"
export * from "./Swap.vue?vue&type=script&lang=js"

import "./Swap.vue?vue&type=style&index=0&id=004a0810&scoped=true&lang=scss"

import exportComponent from "/Users/james/Desktop/VueJS/ingredient-swap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004a0810"]])

export default __exports__